import OlMap from 'ol/Map';

import { 
	postRequestJson,
	postRequestBody
} from 'lib/utilities/network';

export async function sendMapScreenshot(blob:string, clientId:number, mapId:number) {
	const res = await postRequestBody(
		`${_config.middleAPI}/api/v1/ac/map-snapshot`,
		JSON.stringify({blob: blob, clientId: clientId, mapId: mapId}),
		{'Authorization': `Bearer NoneYet`}
	);
	
	if(res.status != 200)
		return null;
	
	const data = await res.json();
	
	return data.key;
}